import { useCallback } from 'react';
import { RootStateOrAny, useSelector, useDispatch } from 'react-redux';
import { ListBusinessUnitsActions } from 'store/ducks/settings/business-unit';

type State = {
  data: { value: number, label: string }[];
  loading: boolean;
}

export function useListBusinessUnits() {
  const dispatch = useDispatch();

  const { data: businessUnits, loading: loadingBusinessUnits } =
    useSelector<RootStateOrAny, State>(
      (state) => state.listBusinessUnits);

  const fetchBusinessUnits = useCallback((
    onSuccess?: (options: State['data']) => void,
  ) => {
    const payload = { all: true };
    dispatch(ListBusinessUnitsActions.request(payload, onSuccess));
  }, [dispatch]);

  return {
    businessUnits,
    loadingBusinessUnits,
    fetchBusinessUnits,
  };
}